<script setup lang="ts" generic="T extends Category | Chapter | Folder">
import type { Category } from "~/models/Content/schemas/content-search.schema"
import type { Chapter, Folder } from "~/types/contentSearch"
import { safeParse } from "valibot"
import { CategorySchema } from "~/models/Content/schemas/content-search.schema"

const { data, toggle, parentLocationIdFilter } = defineProps<{
  data: T[]
  parentLocationIdFilter?: number | string
  toggle: (id: T["id"]) => ReturnType<typeof navigateTo>
}>()

function isCategory(data: unknown): data is Category {
  return safeParse(CategorySchema, data).success
}

const filteredItems = computed(() => {
  if (!parentLocationIdFilter)
    return data

  return data.filter(item => !("parentLocationId" in item) || item.parentLocationId === parentLocationIdFilter)
})
</script>

<template>
  <section class="text-mobile-article-preview-p1 space-y-4 md:text-desktop-article-preview-p1">
    <UFeatureFlag><span>Total: {{ filteredItems.reduce((sum, i) => sum + i.results, 0) }}</span></UFeatureFlag>
    <div
      v-for="item in filteredItems"
      :key="item.id"
      :class="{ 'opacity-60': item.results === 0 && !isCategory(item) }"
    >
      <label
        class="group mb-1 flex w-full cursor-pointer select-none items-center md:mb-2"
      >
        <USearchCheckbox
          :model-value="item.active"
          @update:model-value="toggle(item.id)"
        />
        <div
          class="ml-2 flex min-w-0 flex-1 items-center gap-2 md:ml-3 md:gap-4"
          :class="{
            'text-[--theme-lighter]': item.results === 0 && !isCategory(item),
          }"
        >
          <div class="min-w-0 flex-1 truncate">
            <span v-if="'priority' in item">{{ item.priority }}.</span> {{ item.title }}
          </div>
          <div v-if="!isCategory(item)" class="ml-1 shrink-0">
            ({{ item.results }})
            <span class="sr-only"> søketreff</span>
          </div>
        </div>
      </label>
      <slot v-if="item.active" :parent-location-id="item.id" />
    </div>
  </section>
</template>
